export default "__VITE_ASSET__btNVX_7L__"